import { useEffect, useState } from "react";
import { DoneIconCircled } from "../../../Icons/Icons";
import { getSalaryCandidate, patchSalaryCandidate } from "../../../API/Candidates/Salary";
import Loading from "../../../Components/Loading/Loading";
import CustomInput from "../components/customInput";
import CustomSelect from "../components/customSelect";
import Swal from "sweetalert2";

import "./step2.sass";
import { firstLoginTranslate } from "../../../i18n/translatedMessages";

const Step2FirstLogin = ({ onNextStep }) => {
  const REGEXNumber = /^\$?(([1-9](\d*|\d{0,2}(,\d{3})*))|0)(.\d{1,2})?$/g;
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState({
    currency: "",
    fixed_value: "",
    variable_salary: "",
  });

  const coins = [
    {
      name: "AR$",
      value: 1,
    },
    {
      name: "CLP",
      value: 1,
    },
    {
      name: "COP",
      value: 1,
    },
    {
      name: "MEX",
      value: 1,
    },
    {
      name: "R$",
      value: 1,
    },
    {
      name: "S/.",
      value: 1,
    },
    {
      name: "USD",
      value: 1,
    },
  ];

  const variable = [0.5, 1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5, 5.5, 6, 6.5, 7, 7.5, 8, 8.5, 9, 9.5, 10];

  useEffect(() => {
    const fetchList = async () => {
      const salaryInfo = await getSalaryCandidate(localStorage.getItem("candidateId"));
      setData(salaryInfo.items[0] ?? data);
      setIsLoading(false);
    };

    fetchList();
  }, []);

  const isFormValid = () => {
    return data.currency === "" || data.fixed_value === "" || data.variable_salary === "";
  };

  const handleStartClick = async () => {
    setIsLoading(true);
    const sendData = {
      currency: data.currency,
      fixed_value: data.fixed_value,
      variable_salary: Number(data.variable_salary),
    };
    const resp = await patchSalaryCandidate(localStorage.getItem("candidateId"), sendData);

    if (resp.status === 200) {
      onNextStep();
    } else {
      setIsLoading(false);
      Swal.fire({
        title: "Hola 👋",
        text: "Algo ha ido mal, inténtalo más tarde!",
        icon: "info",
        confirmButtonText: "Ok",
      });
    }
  };
  const handleChange = (event) => {
    const name = event.target.name;
    let value = event.target.value;

    if (name === "fixed_value") {
      value = value.replace(/[^0-9.,]/g, "");
      value = value.replace(/([.,])[.,]+/g, "$1");
    }

    setData({
      ...data,
      [name]: value,
    });
  };

  const currency = (event) => {
    const name = event.target.name;
    let value = event.target.value;
    // let value = e.target.value;
    value = value.replace(/\D/g, "");
    value = value.replace(/(\d)(\d{2})$/g, "$1,$2");
    value = value.replace(/(?=(\d{3})+(\D))\B/g, ".");

    event.target.value = value;
    setData((data) => ({
      ...data,
      [name]: value,
    }));
    return event;
  };

  return (
    <>
      {isLoading ? (
        <Loading />
      ) : (
        <div className=" me-5 text-white w-100">
          <div className="mb-3" style={{ color: "#41C8FF" }}>
            Etapa 2 de 3
          </div>
          <h3>
            <strong>{firstLoginTranslate.step2Title}</strong>
          </h3>
          <div className="mb-3 text-gray">{firstLoginTranslate.step2Text}</div>

          <div className="step2-form p-0 mt-5">
            <div className="custom-label fw-bold" style={{ color: "#CACCFC" }}>
              {firstLoginTranslate.step2FixedSalary}
            </div>
            <div className="mb-5 d-flex">
              <div className="col col-1" style={{ width: "60px" }}>
                <CustomSelect name={"currency"} customId={"name"} value={data.currency} list={coins} propriety={"name"} onChange={handleChange} />
              </div>
              <div className="col ps-2">
                <CustomInput pattern={REGEXNumber} value={data.fixed_value} name={"fixed_value"} onChange={(e) => currency(e)} />
              </div>
            </div>

            <div className="mb-5">
              <CustomSelect label={firstLoginTranslate.step2VariableSalary} name={"variable_salary"} value={data.variable_salary} list={variable} onChange={handleChange} />
            </div>
          </div>

          <button className="custom-btn mt-5" disabled={isFormValid()} style={{ backgroundColor: isFormValid() ? "gray" : "" }} onClick={handleStartClick}>
            Seguir
          </button>
        </div>
      )}
    </>
  );
};

export default Step2FirstLogin;
